import { render, staticRenderFns } from "./crud-form.vue?vue&type=template&id=79de80a2&"
import script from "./crud-form.vue?vue&type=script&lang=js&"
export * from "./crud-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports